import AOS from 'aos';
import { orderFilteredArticles } from './blog-grid-articles-ui';

const initFilters = () => {
	let isSelectOpening = false;

	$('.js-fade-select').on('select2:open', function() {
		$(this).closest('.js-filters-section').addClass('active');

		isSelectOpening = true;

		setTimeout(() => {
			isSelectOpening = false
		}, 10)
	});

	$('.js-fade-select').on('select2:close', function() {
		if ( !isSelectOpening ) {
			$(this).closest('.js-filters-section').removeClass('active');
		}
	});

	$('.js-filters-section').each(function() {
		const $container = $(this);
		const $selects = $container.find('select');
		const $originalSlides = $container.find('.swiper-slide');
		const $form = $container.find('form');
		const splitInColumns = $container.data('in-columns');
		const $items = $container.find('.js-filter-item');
		let slider;
		let manualSelectChange = true;

		if (!splitInColumns) {
			slider = $container.find('.swiper-container')[0].swiper;
		}

		$selects.on('change', function() {
			if ( manualSelectChange ) {
				$form.trigger('submit');
			}
		});

		$form.on('reset', function() {
			setTimeout(() => {
				manualSelectChange = false;

				$(this).find('select').trigger('change')

				onFilter();

				manualSelectChange = true;
			}, 10);
		});

		$form.on('submit', function(event) {
			event.preventDefault();

			onFilter();
		});

		function onFilter () {
			const filters = getFormValues($container);

			if ( splitInColumns ) {
				orderFilteredArticles($container, doFilteringInColumns($items, filters));
			} else {
				doFiltering(slider, filters, $originalSlides);
			}


			AOS.refresh();
		}
	});
}


const getFormValues = ($container) => {
	let filterRanges = [];
	let multipleClass = [];

	$container.find('.js-filter-select').each(function() {
		const $this = $(this);
		const val = $this.val();
		const type = $this.data('type') ? $this.data('type') : 'class';

		if ( type === 'range' && val != '*' && val != '' ) {
			const key = $this.data('key');
			const [min, max] = val.split('-');

			filterRanges.push({
				key,
				min,
				max
			});
		} else {
			if (val != '' && val != '*' ) {
				multipleClass.push(val);
			}
		}
	});

	return {
		filterRanges,
		multipleClass
	};
}

function doFiltering(slider, filters, $slides) {
	let visibleSlides = $slides;

	slider.removeAllSlides();

	if ( filters.multipleClass.length ) {
		visibleSlides = visibleSlides.filter((index, slide) => {
			return shouldShowItemByMultipleClass($(slide), filters.multipleClass);
		});
	}

	for (let i = 0; i < filters.filterRanges.length; i++) {
		const range = filters.filterRanges[i];

		visibleSlides = visibleSlides.filter((index, slide) => {
			return shouldShowItemByRange($(slide), range.key, range.min, range.max);
		});
	}

	// Do something if no slides
	// $(this.sliderSelector).toggleClass('disabled', visibleSlides.length <= 1);

	slider.appendSlide(visibleSlides);
}

function shouldShowItemByMultipleClass($el, selectorsArr) {
	let shouldShowItem = false;
	let matchAll = true;
	let counter = 0;

	for (let i = 0; i < selectorsArr.length; i++) {
		const selector = selectorsArr[i];

		if (selector !== '' && selector !== '*') {
			if ( $el.hasClass(selector.replace('.', '')) ) {
				shouldShowItem = true;
			} else {
				matchAll = false;
			}
		}

		if (selector === '*') {
			counter++;
		}
	}

	return counter === selectorsArr.length ? true : shouldShowItem && matchAll;
}

function shouldShowItemByRange($el, attribute, min, max) {
	const value = parseInt($el.data(attribute));
	let shouldShowItem = false;

	if ( min <= value && max >= value ) {
		shouldShowItem = true;
	}

	return shouldShowItem;
}

function doFilteringInColumns($items, filters) {
	let $filteredItems = $items;

	if ( filters.multipleClass.length ) {
		$filteredItems = $filteredItems.filter((index, item) => {
			return shouldShowItemByMultipleClass($(item), filters.multipleClass);
		});
	}


	return $filteredItems;
}

export default initFilters;

